import React, { useEffect, useRef } from 'react'

export const s3Bucket = "https://hls-video.jpbgdigital.com/kelowna10/hls-content/"

export function getAdsUrl(categories) {
    let url = ''
    const secondsSinceEpoch = String(Math.round(new Date().getTime() / 1000))

    let urlCategories = JSON.stringify(categories);
    urlCategories = encodeURI(urlCategories)
  
    url = 'https://adfetcher.jpbgdigital.com/?site=Kelowna10&categories=' + urlCategories + '&cache_bust=' + secondsSinceEpoch + '&platform=web'
    return url
}

export function getCategoryArray(posts) {
    let categoryArray = posts.map((post) => {
        var returnCategories = []
        post.categories.forEach((cat) => {
            returnCategories.push(cat.name.toLowerCase())
        })
        if (post.linkedAd) {
            returnCategories.push('linkedAd:' + post.linkedAd)
        }
        if (returnCategories.length == 0) {
            returnCategories.push('default')
        }
        return returnCategories
    })

    return categoryArray
}

// https://github.com/christo-pr/dangerously-set-html-content
export function DangerouslySetHtmlContent(props) {
    const { html, ...rest } = props
    const divRef = useRef(null)
  
    useEffect(() => {
      if (!html) return
  
      const slotHtml = document.createRange().createContextualFragment(html) // Create a 'tiny' document and parse the html string
      divRef.current.innerHTML = '' // Clear the container
      divRef.current.appendChild(slotHtml) // Append the new content
    }, [html])
  
  
    return (
      <div {...rest} ref={divRef}></div>
    )
  }
